export type MemoryCategory =
| 'csrf_protection'
| 'authentication_flow'
| 'user_identity_mapping'
| 'session_cookies'
| 'profile_verification_pages'
| 'not_found_behavior'
| 'unauthenticated_access_patterns';
export type MemoryData = {
content: string;
category?: MemoryCategory;
};
export type MemoryRecord = {
content: string;
score?: number;
recordId?: string;
};
export type MemorySearchResult = {
memories: MemoryRecord[];
count: number;
};
export const MEMORY_CATEGORY_LABELS: Record<MemoryCategory, string> = {
csrf_protection: 'CSRF Protection',
authentication_flow: 'Authentication Flow',
user_identity_mapping: 'User Identity',
session_cookies: 'Session & Tokens',
profile_verification_pages: 'Profile Pages',
not_found_behavior: 'Not Found Behavior',
unauthenticated_access_patterns: 'Unauth Access',
};
export const MEMORY_CATEGORY_DESCRIPTIONS: Record<MemoryCategory, string> = {
csrf_protection: 'CSRF token location, implementation, enforcement status',
authentication_flow: 'Step-by-step technical authentication process',
user_identity_mapping: 'User identifiers (username, email, API key, IDs)',
session_cookies: 'Cookie/token names, attributes, headers, storage',
profile_verification_pages: 'Profile URLs and verification page patterns',
not_found_behavior: 'Status codes, redirects, error page patterns',
unauthenticated_access_patterns:
'Unauth responses, login redirects, access denial',
};
